import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formateMessageDatePipe'
})
export class FormateMessageDatePipePipe implements PipeTransform {

  transform(date, lang): unknown {
    var cdate = new Date(date);

    if(lang == 'fi'){
      //If date is today
      if(cdate.getDate() == new Date().getDate() && cdate.getMonth() == new Date().getMonth() && cdate.getFullYear() == new Date().getFullYear()){
        //Return tänään klo 12:00
        return 'tänään klo ' + cdate.getHours() + ':' + cdate.getMinutes();
      }
      //If date is yesterday
      else if(cdate.getDate() == new Date().getDate() - 1 && cdate.getMonth() == new Date().getMonth() && cdate.getFullYear() == new Date().getFullYear()){
        //Return eilen klo 12:00
        return 'eilen klo ' + cdate.getHours() + ':' + cdate.getMinutes();
      }
      else{
        //Return date
        console.log(cdate)
        return cdate.getDate() + '.' + (cdate.getMonth() + 1) + '.' + cdate.getFullYear() + ' klo ' + cdate.getHours() + ':' + cdate.getMinutes();

      }
    }
  }

}
